import { Texture } from "@/core/backends/webgl/texture"
import { RenderPass } from "@/core/pipeline/render-pass"
import { Renderer } from "@/core/pipeline/renderer"
import { ColorProfileName } from "@/core/types"

export class RawProfilePass extends RenderPass {
	constructor(renderer: Renderer, id: string) {
		super(renderer, id)
	}

	public render(inputTexture: Texture, outputTexture: Texture) {
		const colorProfile = this.renderer.profileManager.getColorProfileForPhoto(
			this.renderer.photo,
		)
		const embeddedProfile = this.renderer.profileManager.embeddedProfile

		if (!embeddedProfile) {
			return
		}

		const gainTableMap = embeddedProfile?.gainTableMap

		let baselineExposure =
			this.renderer.photo.type !== "bitmap" ? (embeddedProfile?.baselineExposure ?? 0) : 0

		if (embeddedProfile && colorProfile !== ColorProfileName.Embedded) {
			baselineExposure = 0.0
		}

		const renderGainTableMap =
			this.renderer.photo.type !== "bitmap" &&
			this.renderer.profileManager.gainTableMapTexture !== null &&
			colorProfile === ColorProfileName.Embedded

		if (gainTableMap && renderGainTableMap) {
			this.renderer.shaders.rawProfile.setUniforms({
				gainMapTexture: 1,
				gainTableOrigin: [gainTableMap.origin_h, gainTableMap.origin_v],
				gainTableSpacing: [gainTableMap.spacing_h, gainTableMap.spacing_v],
				gainTableSize: [
					gainTableMap.points_h,
					gainTableMap.points_v,
					gainTableMap.points_n,
				],
				gainTableWeightsFirst: gainTableMap.input_weights.slice(0, 3),
				gainTableWeightsSecond: gainTableMap.input_weights.slice(3, 5),
			})
		}

		this.renderer.shaders.rawProfile.setUniforms({
			inputTexture: 0,
			gainMapTexture: 1,
			baselineExposure: baselineExposure,
			renderGainTableMap,
		})

		outputTexture.bindFramebuffer()

		inputTexture.bind(0)
		this.renderer.profileManager.gainTableMapTexture?.bind(1)

		this.renderer.shaders.rawProfile.draw()
	}

	dispose() {
		return
	}
}
